module.exports = __webpack_public_path__ + "static/logoBG-0297d92d259bf91a6de5211a0fd25a95.png";